define.alias("ember-composable-helpers/helpers/compact", "settings/helpers/compact");